import React, { useRef, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Snackbar,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import emailjs from "@emailjs/browser";

export default function Contact() {
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const theme = useTheme();

  // Email Js
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_uqrak85",
        "template_cj7wcal",
        form.current,
        "MIy_Vwyaz5ycf-VcH"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    e.target.reset();
  };

  const customProps = {
    style: {
      color: theme.palette.common.white,
      background: "rgb(23, 23, 23)",
    },
  };
  return (
    <>
      <Box
        sx={{ width: "92%", margin: "0 auto", marginBottom: "50px" }}
        id="contact"
      >
        <Typography
          variant="h1"
          sx={{
            color: theme.palette.common.white,
            marginTop: "26px",
            letterSpacing: "1px",
            lineHeight: "58px",
            width: "80%",
          }}
        >
          Let's Chat 👋
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "rgb(128, 128, 128)",
            fontSize: "16px",
            fontWeight: 200,
            marginTop: "15px",
            width: "97.2%",
          }}
        >
          If you'd like to talk about a potential project or just say hi, send
          me a message or email me at joshuachivile@gmail.com!
        </Typography>
        <Box>
          <form ref={form} onSubmit={sendEmail}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  id="outlined-basic"
                  placeholder="Name"
                  required
                  fullWidth
                  type="text"
                  name="name"
                  sx={{
                    marginTop: "20px",
                    border: "none",
                  }}
                  InputProps={customProps}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="outlined-basic"
                  placeholder="Email"
                  fullWidth
                  required
                  type="email"
                  name="email"
                  sx={{
                    marginTop: "20px",
                    border: "none",
                  }}
                  InputProps={customProps}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="outlined-message"
                  placeholder="Message"
                  name="message"
                  fullWidth
                  required
                  multiline
                  rows={5}
                  InputProps={customProps}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{
                    textAlign: "center",
                    backgroundColor: "rgb(252, 163, 17)",
                    width: "100%",
                  }}
                  onClick={() => setOpenSnackBar(true)}
                >
                  Send Message
                </Button>
              </Grid>
              <Snackbar
                open={openSnackBar}
                autoHideDuration={6000}
                onClose={() => setOpenSnackBar(false)}
                message="Message Sent. I'll get back to you soon 🙂"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              />
            </Grid>
          </form>
        </Box>
      </Box>
    </>
  );
}
